<script setup>
  import { useI18n } from 'vue-i18n';
  import Icon from '@/components/icons/Icon.vue';

  const { t } = useI18n();

  const model = defineModel({ type: Array });

  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
</script>

<template>
  <div class="jwx-modal__section">
    <div class="jwx-modal__section-body">
      <ul class="jwx-block jwx-table-view" data-surface="1">
        <li v-for="day in days" :key="day" class="jwx-table-view__row">
          <div class="jwx-table-view__row-content">
            <label :for="'day-' + day" class="jwx-table-view__row-label">{{ t('common.dayAbbreviations.' + day.toLowerCase()) }}</label>
            <div class="jwx-table-view__row-actions">
              <div class="jwx-radio-control">
                <input
                  type="checkbox"
                  name="day"
                  :id="'day-' + day"
                  :value="day"
                  v-model="model"
                  class="jwx-radio-control__input jwx-hidden-control"
                />
                <label :for="'day-' + day" class="jwx-radio-control__label">
                  <p class="sr-only">{{ t('windAlerts.srSelectDay', { day: t('common.dayAbbreviations.' + day.toLowerCase()) }) }}</p>
                  <span class="jwx-radio-control__selection-indicator">
                    <Icon v-if="model.includes(day)" name="checkmark" class="jwx-radio-control__indicator-icon" />
                  </span>
                </label>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
